import { createRequest, platform } from "@shared/platform-api/requests"
import makeUUID from "@shared/utils/helpers/makeUUID"
import { createRequestHook } from "../createRequestHook"
import { Viewer } from "./types"
import { extractData } from "../../auth/api/utils"

export const viewer = createRequest<{}, Viewer>(async (_, getToken) => {
  const token = await getToken()
  const data = extractData(token)

  const user = await platform(getToken).users.findUser({ id: data.id })

  switch (data.type) {
    case `admin`:
      return {
        type: `flocker`,
        id: makeUUID(data.id),
        email: user.email,
        name: user.name,
      }

    case `distributor`:
      return {
        type: `broker`,
        id: makeUUID(data.id),
        email: user.email,
        name: user.name,
      }

    case `customer`:
      return {
        type: `customer`,
        id: makeUUID(data.id),
        email: user.email,
        name: user.name,
      }

    case `claims_admin`:
      return {
        type: `claims_admin`,
        id: makeUUID(data.id),
        email: user.email,
        name: user.name,
      }

    case `carrier`:
      return {
        type: `carrier`,
        id: makeUUID(data.id),
        email: user.email,
        name: user.name,
      }

    default:
      throw new Error(`This will never happen`)
  }
})

export const useViewer = createRequestHook(viewer)
